module.exports = __webpack_public_path__ + "img/honduras.f40a4e6f.svg";